import { ConfigProvider as AntdConfigProvider } from 'antd'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { ConfigProvider as ConfigProviderComponent } from './ConfigProvider'

export const ConfigProvider = hoistNonReactStatics(
  ConfigProviderComponent,
  AntdConfigProvider
)
